const columns = [
  {
    title: "高频问题",
    links: [
      { label: "黑料网站靠谱吗", href: "#index" },
      { label: "黑料网站好用吗", href: "#index" },
      { label: "黑料网站打不开", href: "#index" },
      { label: "黑料网站审核慢", href: "#index" },
    ],
  },
  {
    title: "更多困扰",
    links: [
      { label: "黑料网站验证多", href: "#index" },
      { label: "黑料网站广告烦", href: "#index" },
      { label: "实时快讯流", href: "#timeline" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "关于本页",
    links: [
      { label: "读者观察报告", href: "#top" },
      { label: "体验图鉴", href: "#index" },
      { label: "读者原话", href: "#feedback" },
      { label: "回到顶部", href: "#top" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                黑
              </span>
              <span className="font-heading text-base font-semibold tracking-wide text-foreground-950">
                黑料网站
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-700">
              一份关于黑料网站的读者观察报告：汇总靠谱吗、好用吗，以及打不开、审核慢、验证多、广告烦的真实体验与解决思路。
            </p>
          </div>

          {columns.map((col) => (
            <nav key={col.title} className="lg:col-span-2">
              <h3 className="font-heading text-sm font-semibold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={`${col.title}-${l.label}`}>
                    <a
                      href={l.href}
                      className="cursor-pointer whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col justify-between gap-3 border-t border-secondary-300 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-600">
            本页为读者反馈汇总，内容仅供参考，请理性看待每一条信息。
          </p>
          <p className="text-xs text-foreground-500">读者观察报告 · 第 09 期 · 2026</p>
        </div>
      </div>
    </footer>
  );
}